module.exports = __webpack_public_path__ + "static/media/pro-3.4f631f77.jpg";